<template>
    <form class="space-y-4" @submit.prevent>
        <div>
            <label class="block text-gray-700 mb-1">Name</label>
            <input
                type="text"
                class="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring focus:border-blue-300"
                v-model="state.form.name.value" v-bind:class="{'border-red-400': state.form.name.error}"
            />
            <div v-if="state.form.name.error" class="text-red-400">
                {{ state.form.name.error }}
            </div>
        </div>
        <div>
            <label class="block text-gray-700 mb-1">Email</label>
            <input
                type="text"
                class="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring focus:border-blue-300"
                v-model="state.form.email_address.value" v-bind:class="{'border-red-400': state.form.email_address.error}"
            />
            <div v-if="state.form.email_address.error" class="text-red-400">
                {{ state.form.email_address.error }}
            </div>
        </div>
        <div>
            <label class="block text-gray-700 mb-1">Password</label>
            <input
                type="password"
                v-model="state.form.password.value" v-bind:class="{'border-red-400': state.form.password.error}" @keydown.enter.prevent="doSignup()"
                class="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring focus:border-blue-300"
            />
            <div v-if="state.form.password.error" class="text-red-400">
                {{ state.form.password.error }}
            </div>
        </div>
        <Button
            type="submit"
            class="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition"
            @click="doSignup" :loading="state.loading" :disabled="state.formErrors"
        >
            Register
        </Button>
    </form>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { api } from '@/utils/api';
import Button from '@/components/Button.vue';

const emit = defineEmits(['success']);

const baseURL = ref(baseUrl);

const props = defineProps({
    user: Object
});

const state = reactive({
    loading: false,
    form: {
        name: {
            label: 'Name',
            value: props.user.first_name,
            required: true,
            error: false
        },
        email_address: {
            label: 'Email',
            value: '',
            required: true,
            error: false
        },
        password: {
            label: 'Password',
            value: '',
            required: true,
            error: false
        },
        /*confirmPassword: {
            label: 'Confirm Password',
            value: '',
            required: true,
            error: false
        }*/
    },
    formErrors: false,
    errors: []
})

const missingRequiredFields = computed(() => {
    const missingFields = [];

    for(const field in state.form) {
        if(!state.form[field].value) {
            missingFields.push(field)
        }
    }

    return missingFields;
});

const doSignup = () => {
    // Reset any form error messages
    for(const field in state.form) {
        if(state.form[field].error) {
            state.form[field].error = false;
        }
    }

    if(missingRequiredFields.value.length > 0) {
        missingRequiredFields.value.forEach(missingField => {
            state.form[missingField].error = 'Please provide a ' + state.form[missingField].label;
        });

        state.formErrors = true;

        return;
    }

    state.loading = true;

    const params = {};
    for(const field in state.form) {
        params[field] = state.form[field].value
    }

    api({
        method: 'POST',
        endpoint: 'api/users' + (props.user.id ? '/' + props.user.id : ''),
        params: params,
        successCallback: (apiResponse) => {
            emit('success');
            state.loading = false;
        },
        errorCallback: (apiResponse) => {
            apiResponse.errors.forEach(error => {
                notify({
                    title: "Validation error",
                    text: error.message,
                    group: "danger",
                    duration: 10000,
                    ignoreDuplicates: true
                });
            })

            state.formErrors = true;
            state.loading = false;
        }
    });
}

</script>